import type { PropsWithChildren } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import CompanyNameWithLinkCell
    from "app/components/React/Table/cells/company-cell/CompanyNameWithLinkCell/CompanyNameWithLinkCell";

import type { BaseLeadCompanyDataModel } from "../../types/table";

import { StyledCompanyInfoWrapper, StyledHeaderWrapper, StyledIconButton } from "./styles";

type Props = PropsWithChildren<{
    companyData: BaseLeadCompanyDataModel;
    onHide(): void;
}>;

const ExpandedRowTableHeaderBase = ({ companyData, children, onHide }: Props) => {
    const { translate } = useTranslate();

    return (
        <StyledHeaderWrapper data-automation="table-header">
            <StyledCompanyInfoWrapper data-automation="company-info">
                <CompanyNameWithLinkCell
                    imgSrc={companyData.favicon}
                    companyName={companyData.companyName}
                    tooltipContent={translate(`table.cell.CompanyCell.tooltip.company-link.text`)}
                    companyOverviewLink={companyData.companyOverviewLink}
                />
            </StyledCompanyInfoWrapper>

            {children}

            <StyledIconButton
                type="flat"
                iconName="clear"
                placement="left"
                onClick={onHide}
            />
        </StyledHeaderWrapper>
    );
};

export default ExpandedRowTableHeaderBase;
